export default __webpack_public_path__ + "media/images/react_icons/arrow-left-line-86f3b2557533a05cc67fa3305a746444.svg";